'use client';

import { createTheme as createMuiTheme } from '@mui/material/styles';

import { baseOptions } from './base';
import { darkThemeOptions } from './dark';

export const defaultTheme = createMuiTheme(baseOptions, darkThemeOptions);
